import React from 'react';
export const IntroSection = () => {
  return <section className="py-6 md:py-8 bg-gradient-to-r from-christmas-green/20 via-bttf-bg to-christmas-red/20 border-t border-b border-christmas-gold/20 relative overflow-hidden" id="book" data-id="element-248">
      {/* Festive Background Elements */}
      <div className="absolute top-5 left-10 text-3xl opacity-10 animate-float" data-id="element-249">
        🎄
      </div>
      <div className="absolute top-10 right-20 text-3xl opacity-10 animate-float" style={{
      animationDelay: '1s'
    }} data-id="element-250">
        🎁
      </div>
      <div className="absolute bottom-10 left-1/3 text-3xl opacity-10 animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-251">
        ⭐
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-252">
        <div className="text-center mb-6" data-id="element-253">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-254">
            <span className="text-2xl animate-twinkle" data-id="element-255">🎄</span>
            <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-festive text-transparent bg-clip-text" data-id="element-256">
              Now Available - Limited Release
            </h2>
            <span className="text-2xl animate-twinkle" style={{
            animationDelay: '1s'
          }} data-id="element-257">
              🎄
            </span>
          </div>
          <div className="w-20 h-1 bg-gradient-christmas mx-auto" data-id="element-258"></div>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-259">
          <p className="text-xl text-center mb-3 text-bttf-text" data-id="element-260">
            <span className="text-christmas-gold font-bold" data-id="element-261">
              This Holiday Season:
            </span>{' '}
            Some films entertain.{' '}
            <span className="font-semibold text-christmas-gold" data-id="element-262">
              A few inspire.
            </span>{' '}
            But once in a lifetime, a story changes how we see time itself.
          </p>
          <p className="text-lg mb-3 text-bttf-subtext" data-id="element-263">
            In 1985, Back to the Future ignited imaginations around the world.
            It wasn't just about time travel—it was about courage, destiny, and
            the magic of friendship between a wild inventor and a kid who just
            wanted to get home.{' '}
          </p>
          <p className="text-lg text-bttf-subtext" data-id="element-264">
            Four decades later, the story still hums like a DeLorean engine under starlight. And now, that legacy is captured forever in Back to the Future: 40th Anniversary Collector's Edition — a cinematic keepsake for dreamers of every generation.
          </p>
        </div>
      </div>
    </section>;
};